// getters
const adminSchools = state => state.adminSchools

export default {
  adminSchools
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/schools/getters.js